import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../atoms/modal/Modal';
import Textlink from '../atoms/link/Textlink';
import LinkButton from '../atoms/button/LinkButton';

const ModalCampaignCaption = ({ open, onClose }) => {
  const couponFaqLink = 'https://www.nta.co.jp/help/faq/mycoupon/';

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="captionModal"
      bodyClassName="cautionModalBody"
      overlayClassName="cautionModalOverlay"
      customHeader={() => (
        <div className="captionModalHeader">
          <div className="captionModalHeaderTitle">お客様がご利用可能な割引・キャンペーン</div>
          <div className="cautionModalClose" onClick={onClose}/>
        </div>
      )}
    >
      <div className="campaignCaption">
        ※割引とマイクーポンは併用できません。<br />
        ※利用条件に一致した割引・マイクーポン・その他キャンペーンのみご利用いただけます。<br />
        ※マイクーポンのご利用について、申込後の変更はできません。<br />
        ※マイクーポン使用条件・有効期限等については、マイページにてご確認ください。<br />
        ※よくある質問は<Textlink to={couponFaqLink} outgoing>こちら</Textlink>
      </div>
      <div style={{ textAlign: 'center', marginTop: 25 }}>
        <LinkButton buttonType="navigateMin" onClick={onClose}>閉じる</LinkButton>
      </div>
    </Modal>
  );
};

ModalCampaignCaption.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalCampaignCaption;
